export default __webpack_public_path__ + "static/media/top_talent_categorisation.6ab63253.svg";